import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const TopCitiesWrap = styled.div`
    margin: 0 -10px 0 -10px;
    padding: 25px;
    row-gap: 20px;
    border-radius: ${BorderRadius.OuterBlockRadius};
    background: ${COLORS.BgLight};
    display: flex;
    flex-wrap: wrap;
  
    @media (min-width: ${wideBreakpoints.mobile}) {
        margin: 0 12px 0 -12px;
        padding: 12px;
        border-radius: ${BorderRadius.componentRadius};
    }

    @media (min-width: ${wideBreakpoints.tablet}) {
        margin: 0 25px 0 -25px;
        padding: 25px;
        border-radius: ${BorderRadius.OuterBlockRadius};
    }
`;

export const TopCityElement = styled.div`
    ${FONTS.XS};
    width: 100%;
    column-gap: 12px;
    cursor: pointer;
    display: flex;
`;
